import React from "react";
import { Button, Badge } from "react-bootstrap";
import { Gem, Star, Rocket } from "lucide-react";

const meta = {
  free: { label: "Free", Icon: Gem, gradient: "bg-plan-free" },
  //starter: { label: "Starter", Icon: Star,   gradient: "bg-plan-starter" },
  pro: { label: "Pro", Icon: Rocket, gradient: "bg-plan-pro" },
};

export default function PlanBadge({ plan = "free", onClick }) {
  const p = meta[plan] ?? meta.free;
  const Icon = p.Icon;

  return (
    <div className=" ms-3 d-inline-block plan_ultra" style={{ top: 0 }}>
      <Button
        className={`plan-pill d-inline-flex align-items-center gap-2 ${p.gradient}`}
        onClick={onClick}
        aria-label="View and manage subscription plan"
      >
        <Icon size={18} />
        <span className="small fw-semibold">Plan:</span>
        <span className="text-capitalize fw-bold">{p.label}</span>
        <Badge bg="light" text="dark" className="ms-1 small shadow-sm">
          Manage
        </Badge>
      </Button>
    </div>
  );
}
